import { forwardRef, memo } from 'react';
import { cx } from '@trinity/chat-components';
import { Filter as FilterIcon } from 'react-feather';
import styles from './style/Project.Clips.module.css';

type Props = {
  className?: string;
  iconClassName?: string;
  disabled?: boolean;
  isActive: boolean;
};

export const Filter = memo(forwardRef<HTMLDivElement, Props>(({
  className,
  iconClassName,
  disabled,
  isActive,
}, ref) => {
  const filterClassName = cx(styles.filterIcon, {
    [styles.active]: isActive,
    [styles.disabled]: disabled,
  }, iconClassName);

  return (
    <div ref={ref} className={className}>
      <FilterIcon
        size={20}
        className={filterClassName} />
    </div>
  );
}));